export default __webpack_public_path__ + "media/images/delete_croix_rouge_16-c93997951dbdce812d55c55623919f55.png";